// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24LuO","newExpiryDate":"styles_newExpiryDate__LToSA","footer":"styles_footer__3upDZ"};